import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ProcessosIframe from "~/components/ProcessosIframe";
import { getIflowFormdata } from "~/store/ducks/processes/actionTypes";
import { setProcessFormMenuItemClicked } from "~/containers/Layout/actions";
import NativeProcessesWrapper from "./NativeProcessesWrapper";
import oauth from "~/utils/oauth";

const ProcessosFormHandler = (props) => {
  const { app, className } = props;
  const dispatch = useDispatch();
  const { currentFormUrl, currentFormMenuItemClicked } = useSelector(
    (state) => state.globalReducer
  );
  const { menu } = useSelector((state) => state.applicationMenuReducer);

  const renderProcesses = () => {
    if (menu && currentFormUrl !== "") {
      const menuItem = menu.find((item) => item.route === `${app}/processos`);
      if (menuItem) {
        const extraConfiguration_ = JSON.parse(
          menuItem.extraConfiguration || false
        );
        const nativeFlows_ = extraConfiguration_.nativeFlows;
        if (nativeFlows_ && currentFormUrl) {
          if (
            nativeFlows_.some((flow) =>
              currentFormUrl.includes(`flowid=${flow}`)
            )
          ) {
            return <NativeProcessesWrapper className={className} />;
          } else return <ProcessosIframe className={className} />;
        } else return <ProcessosIframe className={className} />;
      }
    }
  };

  useEffect(() => {
    if (menu && currentFormUrl !== "" && currentFormMenuItemClicked === true) {
      const menuItem = menu.find((item) => item.route === `${app}/processos`);
      if (menuItem) {
        const extraConfiguration_ = JSON.parse(
          menuItem.extraConfiguration || false
        );
        const nativeFlows_ = extraConfiguration_.nativeFlows;
        if (nativeFlows_ && currentFormUrl) {
          if (
            nativeFlows_.some((flow) =>
              currentFormUrl.includes(`flowid=${flow}`)
            )
          ) {
            const payload = {
              url: currentFormUrl + "&Authorization=" + oauth.getAccessToken(),
            };
            dispatch(getIflowFormdata(payload));
            dispatch(setProcessFormMenuItemClicked(false));
          }
        }
      }
    }

    return () => {
      //clear accordions state
      localStorage.removeItem("iflowAccordion");
    };
  }, [menu, currentFormUrl, currentFormMenuItemClicked]);

  return <>{renderProcesses()}</>;
};
export default ProcessosFormHandler;
